import { useEffect, useRef } from "react"
import { useBaseMap } from "../BaseMap"
import { HereGeocodePosition } from "../../../models/MapModels"
import { isRealPosition } from "../mapUtils"

interface IProps {
    position?: HereGeocodePosition
    /** Shown on hover. */
    title?: string
    onClick?: () => void
    /** The pin can be dragged to the right spot -- where an address is being picked. */
    draggable?: boolean
    /** Where a dragged pin was let go. */
    onMoved?: (position: HereGeocodePosition) => void
}

/** The job's address: the house pin, above everything else on the map. */
export default function JobMarkerLayer(props: IProps) {

    const { L, map } = useBaseMap()
    const onClick = useRef(props.onClick)
    onClick.current = props.onClick
    const onMoved = useRef(props.onMoved)
    onMoved.current = props.onMoved

    const lat = props.position?.lat, lng = props.position?.lng

    useEffect(() => {
        if (!isRealPosition(props.position)) return

        // A draggable pin is a little larger: it is there to be taken hold of.
        const size = props.draggable ? 50 : 40
        const marker = L.marker([props.position.lat, props.position.lng], {
            icon: L.icon({
                iconUrl: "/assets/media/mapmarkers/client.png",
                iconSize: [size, size],
                iconAnchor: [size / 2, size],
                tooltipAnchor: [0, -size]
            }),
            keyboard: false,
            draggable: !!props.draggable,
            zIndexOffset: 2000
        })
        if (props.title) marker.bindTooltip(props.title, { direction: "top" })
        marker.on("click", () => onClick.current?.())
        marker.on("dragend", () => {
            const p = marker.getLatLng()
            onMoved.current?.({ lat: p.lat, lng: p.lng })
        })
        marker.addTo(map)

        return () => { marker.remove() }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map, lat, lng, props.title, props.draggable])

    return null
}
